import { useMemo } from "react";

let idCounter = 0;

export const useSafeId = (prefix = "tooltip") => {
  return useMemo(() => {
    idCounter += 1;
    return `${prefix}-${idCounter}`;
  }, []);
};
